import { Box } from '@mui/system';
import { FormHook } from 'app/hooks';
import { Button, TextField, Typography } from 'app/shared';
import { IDrugTestList, IReportRetryProcessing, IReportSchema, IReportStatus } from 'generated/axios';
import { getDrugTestTypeLabel } from './substances';
import { useState } from 'react';
import { t } from 'i18next';
import { MenuItem } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import theme from 'theme';

interface Props {
  detail: IReportSchema | undefined;
  imageUrl: string | undefined;
  retryForm: FormHook<IReportRetryProcessing>;
  loading: boolean;
  getPhotoBlister: () => void;
}

export const ReportImageColumn = ({ imageUrl, retryForm, detail, loading, getPhotoBlister }: Props) => {
  const [retryReadOnly, setRetryReadOnly] = useState<boolean>(true);
  const toggleRetryReadOnly = () => setRetryReadOnly((prev) => !prev);
  const { bindSelect: bindRetrySelect, submit: submitRetry } = retryForm; //rename due to conflicts

  return (
    <>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <Typography>
          {t('report.testType')}: {retryReadOnly && getDrugTestTypeLabel(detail?.test_result?.drug_test_type)}
        </Typography>
        {!retryReadOnly && (
          <TextField size="small" sx={{ m: 1 }} {...bindRetrySelect({ field: 'drug_test_type_override' })}>
            {Object.entries(IDrugTestList).map(([key, val]) => (
              <MenuItem key={key} value={val}>
                {getDrugTestTypeLabel(val)}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Box>
      <Box textAlign={'center'}>
        {retryReadOnly ? (
          <Button loading={loading} onClick={toggleRetryReadOnly}>
            {t('report.updateTest')}
          </Button>
        ) : (
          <>
            <Button
              loading={loading}
              color="warning"
              onClick={() => {
                submitRetry();
                toggleRetryReadOnly();
              }}
            >
              {t('actions.submit')}
            </Button>
            <Button loading={loading} onClick={toggleRetryReadOnly}>
              {t('actions.cancel')}
            </Button>
          </>
        )}
      </Box>

      {detail?.has_photo_blister !== false ? (
        imageUrl ? (
          <Box position={'sticky'} top={0} padding={'20px'}>
            <img alt="blister" src={imageUrl} width={'100%'} style={{ objectFit: 'contain' }} />
            <Box
              padding={1}
              gap={1}
              sx={{ textAlign: 'start', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}
            >
              {detail?.report_status === IReportStatus.Error && (
                <label style={{ color: theme.palette.error.main }}>{t('report.uploadBlisterError')}</label>
              )}
              <Button onClick={getPhotoBlister} loading={loading}>
                {t('actions.download')}
              </Button>
            </Box>
          </Box>
        ) : (
          <Box>
            <CircularProgress />
          </Box>
        )
      ) : (
        <label>{t('report.noPhotoBlister')}</label>
      )}
    </>
  );
};
